import React, { useState } from "react";
import Sidebar from "../../Component/Sidebar/Sidebar";
import Header from "../../Component/Header/Header";
import Tabs from "./components/Tabs/Tabs";
import FinancialsTab from "./components/FinancialsTab/FinancialsTab";
import EmployeesTab from "./components/EmployeesTab/EmployeesTab";
import PayrollTab from "./components/PayrollTab/PayrollTab";
import ExpensesTab from "./components/ExpensesTab/ExpensesTab";
import styles from "./Accounting.module.css";
import {
  FinancialsIcon, EmployeesIcon, ExpensesIcon, PayrollIcon,
} from "../../Component/Shared/Icon/Icon"; // ⚠️ ضيف FinancialsIcon لو مش موجودة

const TABS = [
  { key: "financials", label: "النظرة المالية", icon: <FinancialsIcon /> },
  { key: "employees",  label: "الموظفين",        icon: <EmployeesIcon /> },
  { key: "payroll",    label: "المرتبات والعمولات", icon: <PayrollIcon /> },
  { key: "expenses",   label: "المصروفات",       icon: <ExpensesIcon /> },
];

const Accounting = () => {
  const [activeTab, setActiveTab] = useState("financials");

  return (
    <div className="apDiv ChatApp">
      <Sidebar />
      <div className="body_container container" dir="rtl">
        <div className="Header">
          <Header />
        </div>
        <div className="Bills">
          <div className={styles.wrapper}>
            <div className={styles.header}>
              <h1 className={styles.title}>الحسابات والمرتبات</h1>
              <p className={styles.subtitle}>إدارة بيانات الموظفين والمرتبات والمصروفات والقوائم المالية</p>
            </div>

            <Tabs tabs={TABS} activeTab={activeTab} onChange={setActiveTab} />

            <div className={styles.content}>
              {activeTab === "financials" && <FinancialsTab />}
              {activeTab === "employees" && <EmployeesTab />}
              {activeTab === "payroll" && <PayrollTab />}
              {activeTab === "expenses" && <ExpensesTab />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accounting;